import React from "react";
import { Modal, ModalBody, ModalHeader, Table, Button } from "reactstrap";

const OrderBill = ({ isOpen, toggle, selectedOrder }) => {
  console.log("🚀 ~ OrderBill ~ selectedOrder:", selectedOrder);
  if (!selectedOrder) return null; // No order selected yet

  const order = selectedOrder; // shortcut
  console.log("🚀 ~ OrderBill ~ order:", order);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        Order Details – {order.orderRefrenceId}
      </ModalHeader>

      <ModalBody style={{ fontFamily: "monospace" }}>
        <div className="p-3">
          {/* ORDER BASIC INFO */}
          <div className="text-center mb-4">
            <h5 className="fw-bold text-uppercase mb-0">Customer</h5>
          </div>

          <div className="d-flex justify-content-between small mb-3">
            <div>
              <strong>Order Date:</strong>{" "}
              {new Date(order.orderDate_Nep).toLocaleDateString()}
            </div>
            <div>
              <strong>Status:</strong> {order.orderStatus}
            </div>
          </div>

          {/* ITEMS */}
          <Table size="sm" bordered responsive className="small mb-1">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th className="text-end">Rate</th>
                <th className="text-center">Qty</th>
                <th className="text-end">Total</th>
              </tr>
            </thead>

            <tbody>
              {order.orderDetails?.length > 0 ? (
                order.orderDetails.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.productName}</td>
                    <td className="text-end">{item.productPrice}</td>
                    <td className="text-center">{item.quantity}</td>
                    <td className="text-end">
                      {item.productPrice * item.quantity}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center text-muted">
                    No items found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* TOTALS */}
          <div className="border-top pt-2 small">
            <div className="d-flex justify-content-between">
              <span>Subtotal</span>
              <span>{order.totalAmount}</span>
            </div>

            <div className="d-flex justify-content-between">
              <span>Discount</span>
              <span>{order.discountAmount}</span>
            </div>

            <div className="d-flex justify-content-between">
              <span>Tax</span>
              <span>{order.taxAmount}</span>
            </div>

            <div className="d-flex justify-content-between fw-bold mt-1">
              <span>Grand Total</span>
              <span>{order.grandTotal}</span>
            </div>
          </div>

          {/* BUTTONS */}
          {/* <div className="mt-3 d-flex justify-content-end gap-2">
            <Button color="primary">Print</Button>
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          </div> */}

          {/* FOOTER */}
          <div className="small mt-3 text-center">**Thank You**</div>
          <div className="small text-center text-muted">
            Powered by Restro Order
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OrderBill;
